import * as React from "react";

const ChevronDown: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M12 13.9688L17.9906 8.00484C18.5238 7.47408 19.4032 7.53757 19.8546 8.1394V8.1394C20.2247 8.63298 20.175 9.3238 19.7379 9.75927L12 17.4688L4.26207 9.75927C3.825 9.3238 3.77526 8.63298 4.14545 8.1394V8.1394C4.59682 7.53757 5.47621 7.47408 6.00935 8.00484L12 13.9688Z" fill="currentColor"/>
        </svg>
    );
};

export default React.memo(ChevronDown);
